import { render } from "./ButtonWhite2.vue?vue&type=template&id=b6ef46e4&scoped=true"
import script from "./ButtonWhite2.vue?vue&type=script&lang=js"
export * from "./ButtonWhite2.vue?vue&type=script&lang=js"

import "./ButtonWhite2.vue?vue&type=style&index=0&id=b6ef46e4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b6ef46e4"

export default script